<template>
  <el-dialog title="出入账调整" :visible.sync="formVisible" :close-on-click-modal="false" width="900px" @close="handleClose">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="100px">
      <el-form-item label="记账类型：" prop="keepAccountsType" class="width100">
        <el-select v-model="form.keepAccountsType" placeholder="请选择" @change="changeKeep">
          <el-option label="系统余额调账" :value="1"></el-option>
          <el-option label="无名客户调账" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <div v-for="(item, index) in form.giveOrDeduction" :key="index">
        <div class="form-title">{{item.userType === 6 ? '入账' : '出账'}}</div>
        <div style="display: flex;align-items: center;position: relative;">
          <el-form-item label="额度：" :prop="'giveOrDeduction.' + index + '.moneyType'" class="width100">
            <el-select v-model="item.moneyType" placeholder="请选择" @change="changeMoneyType(index,item)">
              <!-- <el-option label="佣金" :value="5" v-if="item.userType === 7"></el-option> -->
              <el-option label="余额账户" :value="1"></el-option>
              <el-option label="零售价账户" :value="2" v-if="form.keepAccountsType === 1"></el-option>
              <el-option label="赠送账户" :value="3" v-if="form.keepAccountsType === 1 || (form.keepAccountsType === 2 && item.userType === 6)"></el-option>
              <!-- <el-option label="积分" :value="4"></el-option> -->
            </el-select>
            <span v-if="item.reason && item.moneyType" style="position: absolute;left: 0;top: 25px;font-size: 12px;color: #666;">原因：{{item.reason}}</span>
          </el-form-item>
          <el-form-item label="" :prop="'giveOrDeduction.' + index + '.money'" class="width100">
            <el-input v-model="item.money" :placeholder="`请输入${item.userType === 6?'赠送':'扣减'}额度`" @input="validateMoney($event, index)" />
          </el-form-item>

        </div>
        <el-form-item label="客户：" :prop="'giveOrDeduction.' + index + '.customerId'" class="width100" v-if="item.moneyType">
          <el-select v-model="item.customerId" :placeholder="`请选择需要${item.userType === 6?'赠送':'扣减'}额度的客户`" clearable filterable :filter-method="(val) => customerFilter(val, index)" @blur="onCustomerBlur(index)" @change="(val) => onCustomerChange(index, val)">
            <el-option v-for="item in item.clientOption" :key="item.id" :label="`${item.name} (${item.pho})(${item.levelName})${item.cityCompanyName || ''}`" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="item.userType === 6 ?'增加原因：':'扣减原因：'" :prop="'giveOrDeduction.' + index + '.userCode'" class="width100">
          <el-select v-model="item.userCode" placeholder="请选择" filterable>
            <el-option v-for="item in getfiltered(index)" :key="item.id" :label="item.configName" :value="item.configKey"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="备注：" :prop="'giveOrDeduction.' + index + '.remark'" class="width100">
          <el-input type="textarea" :placeholder="`请输入${item.userType === 6?'赠送':'扣减'}原因`" v-model="item.remark" maxlength="200" show-word-limit />
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading" :disabled="isSubmitDisabled">{{ confirmButtonText }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import { debounce } from 'lodash'
import submitLockMixin from '@/utils/submitLockMixin'
function initFormBean() {
  return {
    keepAccountsType: null,
    giveOrDeduction: [
      {
        customerId: null,
        moneyType: null,
        // userCode: null,
        remark: null,
        money: null,
        userType: 6
      },
      {
        customerId: null,
        moneyType: null,
        // userCode: null,
        remark: null,
        money: null,
        userType: 7
      }
    ]
  }
}

export default {
  name: 'EntryExitDialog',
  mixins: [submitLockMixin],
  props: {
    reasonOptions: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      formRules: {
        keepAccountsType: [{ required: true, message: '请选择记账类型', trigger: 'change' }],
        'giveOrDeduction.0.customerId': [{ required: true, message: '请选择客户', trigger: 'change' }],
        'giveOrDeduction.0.moneyType': [{ required: true, message: '请选择账户', trigger: 'change' }],
        // 'giveOrDeduction.0.userCode': [{
        //   required: true,
        //   message: '请选择赠送原因',
        //   trigger: 'change'
        // }],
        'giveOrDeduction.0.money': [{
          required: true,
          message: '请输入额度',
          trigger: 'blur'
        }, {
          pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/,
          message: '请输入正确的额度'
        }],
        'giveOrDeduction.1.customerId': [{
          required: true,
          message: '请选择客户',
          trigger: 'change'
        }],
        'giveOrDeduction.1.moneyType': [{
          required: true,
          message: '请选择账户',
          trigger: 'change'
        }],
        // 'giveOrDeduction.1.userCode': [{
        //   required: true,
        //   message: '请选择原因',
        //   trigger: 'change'
        // }],
        'giveOrDeduction.1.money': [{
          required: true,
          message: '请输入额度',
          trigger: 'blur'
        }, {
          pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/,
          message: '请输入正确的额度'
        }]
      },
      clientOption: [],
    }
  },

  created() {
    this.debouncedGetOption = debounce(this.getOption, 500)
  },
  methods: {
    changeKeep() {
      this.form.giveOrDeduction.forEach(item => {
        item.moneyType = ''
        item.reason = ''
        item.userCode = null
      })
    },
    changeKeepAccounts(index) {
      let { keepAccountsType } = this.form
      console.log(keepAccountsType, index)
      if (!index && index != 0) return
      let { moneyType, userType } = this.form.giveOrDeduction[index]
      if (!moneyType) return
      if (keepAccountsType) {
        managecustomerwalletApi.getReasonListByType(keepAccountsType, moneyType).then(({ data }) => {
          this.form.giveOrDeduction[index].reason = userType === 6 ? data.inType.configName : data.outType.configName
          this.form.giveOrDeduction[index].userCode = userType === 6 ? data.inType.configKey : data.outType.configKey
          if (this.form.keepAccountsType === 1) {
            // 系统余额调账：入账行用inType，出账行用outType
            this.form.giveOrDeduction[0].reason = data.inType.configName
            this.form.giveOrDeduction[0].userCode = data.inType.configKey
            this.form.giveOrDeduction[1].reason = data.outType.configName
            this.form.giveOrDeduction[1].userCode = data.outType.configKey
          }
          if (this.form.keepAccountsType === 2) {
            this.form.giveOrDeduction[1].reason = data.outType.configName
            this.form.giveOrDeduction[1].userCode = data.outType.configKey
          }
          this.$forceUpdate()
        })
      }
    },
    changeMoneyType(index, item) {
      console.log(this.form.keepAccountsType, item)
      if (this.form.keepAccountsType === 2 && item.userType === 7) return
      this.changeKeepAccounts(index)
      this.getOption('', index, 1)
    },
    customerFilter(value, index) {
      this.debouncedGetOption(value, index)
    },

    resetForm() {
      this.form = initFormBean()
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate()
      }
    },
    getfiltered(index) {
      const { moneyType } = this.form.giveOrDeduction[index];
      if (moneyType !== 4 && this.reasonOptions) {
        return this.reasonOptions.filter(it => it.dataType === 1);
      }
      return this.reasonOptions || [];
    },
    // 客户下拉框失焦：把 filter-method 过滤剩下的选项恢复成完整列表。
    // 这里必须走 keepSelected，绝不能直接调 getOption —— getOption 会清空 customerId，
    // 而失焦发生在「选中客户之后」，结果就是选完一移开焦点 customerId 就没了，
    // 提交时必报「请选择客户」，弹层永远提交不了。
    onCustomerBlur(index) {
      this.getOption('', index, null, true)
    },

    /**
     * 拉取客户下拉数据。
     * @param keepSelected true 时保留已选中的客户（失焦恢复列表用）；
     *        默认清空，因为切换账户类型后原客户不一定还在新类型的可选范围内。
     */
    async getOption(e, index, type, keepSelected) {

      if (type) this.getfiltered(index)
      if (!this.form.giveOrDeduction[index].moneyType) return
      const item = this.form.giveOrDeduction[index]
      if (!keepSelected) {
        item.customerId = null
        this.$set(item, '_selectedCustomer', null)
      }
      const params = {
        pageNo: 1,
        pageSize: 100,
        type: item.moneyType
      }
      if (e) params.name = e
      try {
        const { data } = await managecustomerwalletApi.findAreaCustomerList(params)
        const list = data || []
        // 全量列表只取前 100 条，通过搜索选中的客户可能不在里面。
        // 不补回去的话 customerId 还在、下拉框却显示空白，看着像没选。
        const selected = item._selectedCustomer
        if (keepSelected && item.customerId && selected &&
            !list.some(c => c.id === item.customerId)) {
          item.clientOption = [selected, ...list]
        } else {
          item.clientOption = list
        }
        this.$forceUpdate()
      } catch (error) {
        this.$message.error('获取客户列表失败')
        console.error('获取客户列表失败:', error)
      }

    },

    validateMoney(value, index) {
      if (value && !/^\d*\.?\d*$/.test(value)) {
        this.form.giveOrDeduction[index].money = value.replace(/[^\d.]/g, '')
      }
    },
    onCustomerChange(index, customerId) {
      if (!customerId) return
      const item = this.form.giveOrDeduction[index]
      const cust = (item.clientOption || []).find(c => c.id === customerId)
      if (cust) {
        this.$set(item, '_customerLevelName', cust.levelName || '')
        // 记住选中项本身，失焦重拉全量列表时要把它补回选项里
        this.$set(item, '_selectedCustomer', cust)
      }
    },

    handleCreate() {
      this.resetForm()
      this.clearCountdownTimer()
      this.formVisible = true
    },

    handleUpdate(row) {
      this.resetForm()
      this.clearCountdownTimer()
      this.form = {
        ...row
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.getOption()
      })
    },

    handleClose() {
      this.clearCountdownTimer()
      this.formVisible = false
      this.resetForm()
    },

    doCreate() {
      if (this.isSubmitDisabled) return
      // 无名客户调账：体验班同城只2个科目，借贷必须相等
      if (this.form.keepAccountsType === 2) {
        const inItem = this.form.giveOrDeduction.find(i => i.userType === 6)
        const outItem = this.form.giveOrDeduction.find(i => i.userType === 7)
        if (inItem && outItem) {
          const inLevel = inItem._customerLevelName || ''
          if (!inLevel.includes('研修班') && !inLevel.includes('体验')) {
            this.$message.error('请检查用户身份是否升级调整完成')
            return
          }
          if (inItem.money && outItem.money && inLevel.includes('体验')) {
            if (Math.abs(Number(inItem.money)) !== Math.abs(Number(outItem.money))) {
              this.$message.error('体验班调账的入账赠送额度和出账扣减额度必须一致')
              return
            }
          }
        }
      }
      this.$refs["dataForm"].validate(async (valid) => {
        if (valid) {
          try {
            this.isLoading = true
            let params = JSON.parse(JSON.stringify(this.form))
            params.giveOrDeduction.forEach(item => {
              item.money = item.userType === 6 ? item.money * 1 : -item.money * 1
              // 添加 receiveCustomerId 的逻辑
              // 添加 receiveCustomerId 的逻辑
              const otherItem = params.giveOrDeduction.find(function (x) {
                return x.userType === (item.userType === 6 ? 7 : 6)
              })
              item.receiveCustomerId = otherItem ? otherItem.customerId : null
              item.keepAccountsType = this.form.keepAccountsType
              delete item.clientOption
              delete item.reason
            });
            await managecustomerwalletApi.giveOrDeductionMoneyList(params.giveOrDeduction)
            this.postCallback()
          } catch (error) {
            this.$message.error('操作失败')
            console.error('操作失败:', error)
          } finally {
            this.isLoading = false
            this.startCountdown()
          }
        }
      })
    },

    postCallback() {
      this.$message.success('操作成功')
      this.formVisible = false
      this.$emit('created')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item.width100 {
  width: 97%;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
}
</style>